 import { useState, useEffect } from "react";
 import { useNavigate, useParams } from "react-router-dom";
 import axios from "api/baseurl";
 import { toast } from "react-toastify";
 import "react-toastify/dist/ReactToastify.css";
 import CircularProgress from "@mui/material/CircularProgress";
 import Box from "@mui/material/Box";
 import Card from "@mui/material/Card";
 import Grid from "@mui/material/Grid";
 import Modal from "@mui/material/Modal";
 import MDBox from "components/MDBox";
 import MDTypography from "components/MDTypography";
 import {
  Typography
} from "@mui/material";
 import MDButton from "components/MDButton";
 import MDInput from "components/MDInput";
 import TextField from "@mui/material/TextField";
 import MenuItem from "@mui/material/MenuItem";
 import InputAdornment from "@mui/material/InputAdornment";
 
 import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
 import DashboardNavbar from "examples/Navbars/DashboardNavbar";
 import { decryptBody } from "encryptionAndDecryption/bodyDecryption";
 import { fetchSecretKey } from "encryptionAndDecryption/secretKeyDecryption";
 import { encryptBody } from "encryptionAndDecryption/bodyEncryption";
 import { Country, State, City } from "country-state-city";
import MedicalAbstractBackground from "./MedicalAbstractBackground ";
 
 
 const SectionHeader = ({ title }) => (
  <Box my={3}>
    <Typography
      variant="h6"
      sx={{ fontWeight: "bold", color: "#2e7fae", borderBottom: "2px solid #2e7fae" }}
    >
      {title}
    </Typography>
  </Box>
);

     function EditHospitalProfile({ isOpen, onRequestClose, id}) {

      
 
   const navigate = useNavigate();
   const [listDetails, setListDetails] = useState({
 
     hospitalId: "",
    hospitalCode: "",
    hospitalName: "",
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    pincode: "",
    country: "",
    phoneNumber: "",
    phonecountrycode:"",
    emergencyphoneNumber: "",
    emergencycountrycode:"",
    email: "",
    website: "",
    gstno:"",
    registrationAuthority:"",
    registrationNumber:"",
    directorName:"",
    ownershipType:"",
    hospitalType:"",
    establishmentYear:"",
    mcaCin:"",
     
    
   
   
   });
   const [countries, setCountries] = useState([]);
 const [states, setStates] = useState([]);
 const [districts, setDistricts] = useState([]);
   const [loading, setLoading] = useState(true);
   const [openEditModal, setOpenEditModal] = useState(false);
   const [locations, setLocations] = useState([]);
   const countryCodes = [
  { code: "+91", name: "India" },
  { code: "+1", name: "USA" },
  { code: "+44", name: "UK" },
  { code: "+61", name: "Australia" },
  { code: "+971", name: "UAE" },
];
 useEffect(() => {
   const fetchLocations = async () => {
     try {
       const secretKey = await fetchSecretKey();
       const token = JSON.parse(localStorage.getItem("loginData"))?.token;
 
       const response = await axios.get("/api/location", {
         headers: { Authorization: `Bearer ${token}` },
       });
 
       if (response.status === 200) {
         const decrypted = decryptBody(response.data, secretKey);
         setLocations(decrypted); // save locations in state
       }
     } catch (err) {
       console.error("Failed to fetch locations", err);
     }
   };
 
   fetchLocations();
 }, []);
 


 useEffect(() => {
  setCountries(Country.getAllCountries());
}, []);

     const fetchCareCoordinatorDetails = async () => {
       try {
         const secretKey = await fetchSecretKey();
         const token = JSON.parse(localStorage.getItem("loginData"))?.token;
         const response = await axios.get(`/api/hospitalprofile/hopsitalprofileid/${id}`, {
           headers: { Authorization: `Bearer ${token}` },
         });
 
         if (response.status === 200) {
           const decryptedData = decryptBody(response.data, secretKey);
           setListDetails(decryptedData);
           setOpenEditModal(true);
         }
       } catch (error) {
         console.error("Error fetching dealer details:", error);
         toast.error("Failed to fetch dealer details.");
       } finally {
         setLoading(false);
       }
     };
 
   
 
    useEffect(() => {
       if (isOpen) {
         fetchCareCoordinatorDetails();
       }
     }, [isOpen]);
 
   const handleInputChange = (e) => {
     const { name, value } = e.target;
     setListDetails((prevDetails) => ({ ...prevDetails, [name]: value }));
   };
 useEffect(() => {
   if (listDetails.country) {
     const statesData = State.getStatesOfCountry(listDetails.country);
     setStates(statesData);
 
     if (listDetails.state) {
       const citiesData = City.getCitiesOfState(listDetails.country, listDetails.state);
       setDistricts(citiesData);
     }
   }
 }, [listDetails.country, listDetails.state]);
 
 
 // when country changes → update states
 const handleCountryChange = (countryCode) => {
   setListDetails((prev) => ({
     ...prev,
     country: countryCode,
     state: "",
     city: "",
   }));
   setStates(State.getStatesOfCountry(countryCode));
   setDistricts([]);
 };
 
 const handleStateChange = (stateCode) => {
   setListDetails((prev) => ({
     ...prev,
     state: stateCode,
     city: "",
   }));
   setDistricts(City.getCitiesOfState(listDetails.country, stateCode));
 };
 
 const handleCityChange = (cityName) => {
   setListDetails((prev) => ({
     ...prev,
     city: cityName,
   }));
 };
 
 
   const handleSubmitEdit = async (e) => {
     e.preventDefault();
     setLoading(true);
     try {
       const secretKey = await fetchSecretKey();
       const token = JSON.parse(localStorage.getItem("loginData"))?.token;
       const encryptedData = encryptBody(listDetails, secretKey);
       const response = await axios.post("/api/hospitalprofile/update", encryptedData, {
         headers: { "Content-Type": "text/plain", Authorization: `Bearer ${token}` },
       });
 
       if (response.status === 200) {
         toast.success("Hospital Profile details updated successfully!");
         onRequestClose();      }
     } catch (error) {
       toast.error("Failed to update Hospital Profile details.");
     } finally {
       setLoading(false);
     }
   };
 
   return (
     <DashboardLayout>
     <MedicalAbstractBackground/>
 
       {loading && (
         <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
           <CircularProgress />
         </Box>
       )}
 
       <Modal open={isOpen}  onClose={onRequestClose}>
       <MDBox
   display="flex"
   justifyContent="center"
   alignItems="center"
   height="100vh"
   p={2}
 >        <Card
   sx={{
     width: { xs: "95%", sm: "90%", md: "800px" }, 
     padding: 3,
     margin: "auto",
     marginTop: "5vh",
     maxHeight: "90vh",
     overflowY: "auto",
   }}
 >            <MDBox pt={4} pb={3} px={3}>
               <MDTypography variant="h6" mb={4} textAlign="center">
                 Update Hospital Profile Details:
               </MDTypography>
 
               <form onSubmit={handleSubmitEdit}>
                 <Grid container spacing={3}>
 
 
                      
                   
                  <SectionHeader title="Core Identification" />
                  <Grid container spacing={2}>

                    <Grid item xs={4}>
                     <MDInput
                       type="text"
                       label="Hospital ID"
                       fullWidth
                       name="hospitalId"
                       value={listDetails.hospitalId}
                       onChange={handleInputChange}
                       required
                     />
                   </Grid>
                   <Grid item xs={4}>
                     <MDInput
                       type="text"
                       label="Hospital Code"
                       fullWidth
                       name="hospitalCode"
                       value={listDetails.hospitalCode}
                       onChange={handleInputChange}
                       required
                     />
                   </Grid>
                    <Grid item xs={4}>
                     <MDInput
                       type="text"
                       label="Hospital Name"
                       fullWidth
                       name="hospitalName"
                       value={listDetails.hospitalName}
                       onChange={handleInputChange}
                       required
                     />
                   </Grid>

                  </Grid>
                  
                   <SectionHeader title="📍 Location & Contact Info" />
            <Grid container spacing={2}>
                    <Grid item xs={6}>
                     <MDInput
                       type="text"
                       label="Address Line 1"
                       fullWidth
                       name="addressLine1"
                       value={listDetails.addressLine1}
                       onChange={handleInputChange}
                       required
                     />
                   </Grid>
                    <Grid item xs={6}>
                     <MDInput
                       type="text"
                       label="Address Line 2"
                       fullWidth
                       name="addressLine2"
                       value={listDetails.addressLine2}
                       onChange={handleInputChange}
                      
                     />
                   </Grid>
                  
                 <Grid item xs={6}>
  <TextField
   select
   fullWidth
   label="Country"
   name="country"
   value={listDetails.country}
   onChange={(e) => handleCountryChange(e.target.value)}
    sx={{
       "& .MuiInputBase-root": {
         height: "45px",  
       },
     }}
 >
  
   {countries.map((c) => (
     <MenuItem key={c.isoCode} value={c.isoCode}>
       {c.name}
     </MenuItem>
   ))}
 </TextField>
 </Grid>
 
                  <Grid item xs={6}>
  <TextField
   select
   fullWidth
   label="State"
   name="state"
   value={listDetails.state}
   onChange={(e) => handleStateChange(e.target.value)}
    sx={{
       "& .MuiInputBase-root": {
         height: "45px",  
       },
     }}
 >
   {states.map((s) => (
     <MenuItem key={s.isoCode} value={s.isoCode}>
       {s.name}
     </MenuItem>
   ))}
 </TextField>
 </Grid>
 
                <Grid item xs={6}>
   <TextField
     select
     fullWidth
     label="City"
     name="city"
     value={listDetails.city}
     onChange={handleInputChange}
     sx={{ "& .MuiInputBase-root": { height: "45px" } }}
   >
     {districts.map((d) => (
       <MenuItem key={d.name} value={d.name}>
         {d.name}
       </MenuItem>
     ))}
   </TextField>
 </Grid>
 
 
                  <Grid item xs={6}>
                     <MDInput
                       type="text"
                       label="Pin"
                       fullWidth
                       name="pincode"
                       value={listDetails.pincode}
                       onChange={handleInputChange}
                       required
                     />
                   </Grid>
                 
 

                   <Grid item xs={6}>
                  <Grid container spacing={1}>
                      <Grid item xs={4}>
                     <TextField
        select
        label="Country Code"
        fullWidth
        value={listDetails.phonecountrycode}
        onChange={(e) =>
  setListDetails({
    ...listDetails,
    phonecountrycode: e.target.value,  // <-- correct key
  })
}

         sx={{
      "& .MuiInputBase-root": {
        height: "45px",  
      },
    }}
    required
      >
          {countryCodes.map((item) => (
                  <MenuItem key={item.code} value={item.code}>
                    {`${item.name} (${item.code})`}
                  </MenuItem>
                ))}
       
      </TextField>
      </Grid>
                   <Grid item xs={8}>
                     <MDInput
                       type="text"
                       label="Contact Number"
                       fullWidth
                       name="phoneNumber"
                       value={listDetails.phoneNumber}
                       onChange={handleInputChange}
                       required
                     />
                   </Grid>

                    </Grid>
                                </Grid>

                      <Grid item xs={6}>
                  <Grid container spacing={1}>
                      <Grid item xs={4}>
                     <TextField
        select
        label="Country Code(Emergency Contact)"
        fullWidth
        value={listDetails.emergencycountrycode}
        onChange={(e) =>
  setListDetails({
    ...listDetails,
    emergencycountrycode: e.target.value,  // <-- correct key
  })
}

         sx={{
      "& .MuiInputBase-root": {
        height: "45px",  
      },
    }}
    required
      >
          {countryCodes.map((item) => (
                  <MenuItem key={item.code} value={item.code}>
                    {`${item.name} (${item.code})`}
                  </MenuItem>
                ))}
       
      </TextField>
      </Grid>          
                 <Grid item xs={8}>
                     <MDInput
                       type="text"
                       label="Emergency Contact Number"
                       fullWidth
                       name="emergencyphoneNumber"
                       value={listDetails.emergencyphoneNumber}
                       onChange={handleInputChange}
                       required
                     />
                   </Grid>

                   
                    </Grid>
                                </Grid>
 
 
                   <Grid item xs={6}>
                     <MDInput
                       type="text"
                       label="Email"
                       fullWidth
                       name="email"
                       value={listDetails.email}
                       onChange={handleInputChange}
                       required
                     />
                   </Grid>

                   <Grid item xs={6}>
                     <MDInput
                       type="text"
                       label="Website"
                       fullWidth
                       name="website"
                       value={listDetails.website}
                       onChange={handleInputChange}
                       required
                     />
                   </Grid>
                   

                   </Grid>

                   <SectionHeader title="📑 Regulatory & Compliance" />
                     <Grid container spacing={2}>
                   <Grid item xs={6}>
                     <MDInput
                       type="text"
                       label="GST Number"
                       fullWidth
                       name="gstno"
                       value={listDetails.gstno}
                       onChange={handleInputChange}
                       required
                     />
                   </Grid>

                   <Grid item xs={6}>
                     <MDInput
                       type="text"
                       label="Registration Authority"
                       fullWidth
                       name="registrationAuthority"
                       value={listDetails.registrationAuthority}
                       onChange={handleInputChange}
                       required
                     />
                   </Grid>

                   <Grid item xs={6}>
                     <MDInput
                       type="text"
                       label="Registration Number"
                       fullWidth
                       name="registrationNumber"
                       value={listDetails.registrationNumber}
                       onChange={handleInputChange}
                       required
                     />
                   </Grid>

                   <Grid item xs={6}>
                     <MDInput
                       type="text"
                       label="Director name"
                       fullWidth
                       name="directorName"
                       value={listDetails.directorName}
                       onChange={handleInputChange}
                       required
                     />
                   </Grid>

                   <Grid item xs={6}>
     <TextField
       select
       fullWidth
       label="Ownership Type"
       name="ownershipType"
       value={listDetails.ownershipType}
       onChange={handleInputChange}
       sx={{
       "& .MuiInputBase-root": {
         height: "45px",  
       },
     }}
       required
     >
      <MenuItem value="Private">Private</MenuItem>
      <MenuItem value="Government">Government</MenuItem>
      <MenuItem value="Trust">Trust</MenuItem>
      <MenuItem value="Corporate">Corporate</MenuItem>
     </TextField>
   </Grid>
                  <Grid item xs={6}>
     <TextField
       select
       fullWidth
       label="Hospital Type"
       name="hospitalType"
       value={listDetails.hospitalType}
       onChange={handleInputChange}
       sx={{
       "& .MuiInputBase-root": {
         height: "45px",  
       },
     }}
       required
     >
       <MenuItem value="Multispecialty">Multispecialty</MenuItem>
      <MenuItem value="Super-specialty">Super-specialty</MenuItem>
      <MenuItem value="Clinic">Clinic</MenuItem>
      <MenuItem value="Nursing Home">Nursing Home</MenuItem>
      <MenuItem value="Diagnostic Center">Diagnostic Center</MenuItem>
     </TextField>
   </Grid>
                  <Grid item xs={6}>
                     <MDInput
                       type="text"
                       label="Establishment year"
                       fullWidth
                       name="establishmentYear"
                       value={listDetails.establishmentYear}
                       onChange={handleInputChange}
                       required
                     />
                   </Grid>

                   <Grid item xs={6}>
                     <MDInput
                       type="text"
                       label="MCA CIN"
                       fullWidth
                       name="mcaCin"
                       value={listDetails.mcaCin}
                       onChange={handleInputChange}
                       required

                       InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <MDButton
                                  onClick={() =>
                                    window.open("https://www.mca.gov.in/", "_blank")
                                  }
                                  style={{
                                    backgroundColor: "#2e7faeff",
                                    color: "#fff",
                                    minWidth: "60px",
                                    height: "5px",
                                    fontSize: "12px",
                                    padding: "0px 4px",
                                     lineHeight: "1",
                                  }}
                                >
                                  Verify Hospital Documents
                                </MDButton>
                              </InputAdornment>
                            ),
                          }}
                     />
                   </Grid>
                   
                   
                 </Grid>
                 
                
                 </Grid>
                 <MDBox mt={3} textAlign="center">
                   <MDButton variant="gradient"  sx={{
    background: "#1A237E",
    color: "#fff",
    "&:hover": {
      background: "#1A237E", 
    },
  }} type="submit">
                     Update Hospital Profile
                   </MDButton>
                   &emsp;
                   <MDButton variant="gradient"  sx={{
    background: "#1A237E",
    color: "#fff",
    "&:hover": {
      background: "#1A237E", // darker shade on hover
    },
  }} onClick={onRequestClose}>
                   Cancel
                   </MDButton>
                 </MDBox>
               </form>
             </MDBox>
           </Card>
         </MDBox>
       </Modal>
     </DashboardLayout>
   );
 }
 
 export default EditHospitalProfile;
 